import { Box } from "@mui/material";
import { RocketLaunchOutlined, ShowChartOutlined } from "@mui/icons-material";
import {
    Button,
    Column,
    ExternalLink,
    OutlinedCard,
    TagText,
    TagTextAlert,
    Text,
    TextVariant,
    useAppPalette
} from "@bridgesplit/ui";
import { COPY } from "app/constants";

export function ComingSoonBanner({ text }: { text: string | undefined }) {
    if (!text) return null;
    return (
        <TagTextAlert color="info" icon="rocket" sx={{ boxSizing: "border-box", width: "100%" }}>
            {text}
        </TagTextAlert>
    );
}

export function ComingSoonTag({ textVariant = "caption" }: { textVariant?: TextVariant }) {
    return (
        <TagText borderRadius={100} color="info" variant="basic" textVariant={textVariant}>
            Coming Soon
        </TagText>
    );
}

export function JoinWaitlistButton({
    fullWidth,
    notifyFormUrl,
    buttonColor = "secondary",
    height
}: {
    fullWidth?: boolean;
    notifyFormUrl: string | undefined;
    buttonColor?: "primary" | "secondary" | "error" | "info" | "success";
    height?: number;
}) {
    if (!notifyFormUrl) {
        return (
            <Button color={buttonColor} fullWidth={fullWidth} disabled height={height}>
               {COPY.BORROW_TERM}
            </Button>
        );
    }

    return (
        <ExternalLink
            href={notifyFormUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: fullWidth ? "block" : "inline-block", width: fullWidth ? "100%" : undefined }}
            onClick={(e) => e.stopPropagation()}
        >
            <Button color={buttonColor} fullWidth={fullWidth} height={height}>
                {COPY.BORROW_TERM}
            </Button>
        </ExternalLink>
    );
}

export function ComingSoonCard({
    isMobile,
    label,
    notifyFormUrl
}: {
    isMobile: boolean;
    label: string;
    notifyFormUrl: string | undefined;
}) {
    const { textSecondary } = useAppPalette();
    return (
        <Column spacing={3}>
            <OutlinedCard hideCard={isMobile} spacing={2}>
                <Column spacing={2} sx={{ alignItems: "center", py: 4 }}>
                    <RocketLaunchOutlined sx={{ fontSize: 32, color: textSecondary }} />
                    <Text color="caption">{label}</Text>
                </Column>
                <JoinWaitlistButton fullWidth notifyFormUrl={notifyFormUrl} />
            </OutlinedCard>
        </Column>
    );
}

export function ComingSoonChartPlaceholder({ label }: { label: string }) {
    const { textSecondary } = useAppPalette();
    return (
        <Box
            sx={{
                height: 200,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                px: 2,
                gap: 1.5
            }}
        >
            <ShowChartOutlined sx={{ fontSize: 32, color: textSecondary }} />
            <Text variant="body1" color="caption">
                {label}
            </Text>
        </Box>
    );
}
